import { HttpContextToken } from '@angular/common/http';

export const HANDLED_ERRORS = new HttpContextToken<number[]>(() => []);
